export default __webpack_public_path__ + "static/media/twitter-outline.4cd5c47a.svg";